import PlatformProxy from '@/core/PlatformProxy.ts';

export const setStorage = (key: string, val: string) => {
  const setStorageFn = PlatformProxy.getInstance().storager.setStorageFn;
  setStorageFn?.(key, val);
};

export const getStorage = (key: string, format: 'json' | 'string' | 'default' = 'json') => {
  const getStorageFn = PlatformProxy.getInstance().storager.getStorageFn;
  let data = getStorageFn?.(key);
  let popData;
  switch (format) {
    case 'json':
      popData = JSON.parse(data);
      break;
    case 'string':
      popData = String(data);
      break;
    case 'default':
      popData = data;
      break;
  }
  return popData;
};

const storager = {
  setStorage,
  getStorage,
};

export default storager;
